import React from "react";
import { Dropdown } from '@fluentui/react';
import { connect } from "react-redux";
import { addElement } from "../../../actions/CreateSiteActions/createSiteActions";
import { ADD_QUOTA } from "../../../actions/types";

class QuotaPicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            possibilities: [],
            quota: null
        }
    }

    _onQuotaChange = (e, v) => {
        this.setState({quota: v.key});
        this.props.sendElement(ADD_QUOTA, v.key);
    }

    componentDidMount() {
        let quotas = this.props.allQuotas
            .filter(x => x.locationId === this.props.location.id && !x.approvalRequired);

        if(this.props.quotaSize !== null){
            this.setState({quota: this.props.quotaSize})
        } else {
            this.setState({quota: quotas.sort((a, b) => (a.default ? -1 : a.quotaSize - b.quotaSize))[0].quotaSize})
        }

        this.setState({possibilities:
            quotas.sort((a, b) => (a.quotaSize - b.quotaSize)).map(x => ({
                key: x.quotaSize,
                text: x.label
            }))
        })
    }

    render() {
        return (
            <div style={{paddingTop: '4px'}} className="item-title">
                <div>Select storage size of your site</div>
                        <div style={containerStyles}>
                            <Dropdown
                                placeholder="Select quota size"
                                onChange={this._onQuotaChange}
                                selectedKey={this.state.quota}
                                options={this.state.possibilities}
                            />
                        </div>
            </div>
        );
    }
}

const containerStyles = {
    marginTop: '6px',
    position: 'relative'
}

const mapActionsToProps = {
    sendElement: addElement
}

const mapStateToProps = state => (
    {
        location: state.newSite.Location,
        allQuotas: state.app.siteQuotas,
        quotaSize: state.newSite.QuotaSize
    }
)

export default connect(mapStateToProps, mapActionsToProps)(QuotaPicker)


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/QuotaPicker.js